<onyx-section
  [heading]="`${I18N}.assignedContractors`"
  [count]="contractorsControl.length"
>
  <form [formGroup]="form()">
    <onyx-dropdown
      [formControl]="form().controls.selectedContractors"
      [options]="CONTRACTORS_SOURCE"
      [multiple]="true"
      [showAddOption]="true"
      addOptionMessage="labels.addNew"
      (selectedOptionValuesChange)="contractors.set($event.values)"
      (addOption)="addContractor()"
      [size]="32"
    ></onyx-dropdown>

    <onyx-table
      [data]="contractorsControl.controls"
      [columns]="COLUMNS"
      [tableShadow]="false"
      [rowSize]="48"
      [rowOptions]="getContractorOptions"
      [notFound]="NOT_FOUND"
      [(pagination)]="pagination"
    ></onyx-table>
  </form>
</onyx-section>
